import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Api
import dashboard_api from '../../../api/dashboard_api';

//Context
import { useAuth } from '../../../context/auth';
import { showMessage } from '../../../helpers/message';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faCheck } from '@fortawesome/free-solid-svg-icons';

export default function Dashboard({ permissoes }) {
    const { setLoading } = useAuth();

    //Estado de navegação
    const navigate = useNavigate();

    //Estado que guarda os tipos de requerimentos
    const [dashboard, setDashboard] = useState([]);

    //Estado de controle de exibição dos valores dos cards
    const [showContent, setShowContent] = useState({});

    const onClick = (index) => {
        setShowContent({
            ...showContent,
            [index]: !showContent[index]
        })
    }
    useEffect(() => {
        setLoading(true);
        dashboard_api.get().then(response => {
            setDashboard(response.data);
            const _showContent = {};
            response.data.map((value, index) => {
                _showContent[index] = false;
            })
            setShowContent(_showContent);
        }).catch(ex => showMessage("Erro", ex.message, "error", null))
            .finally(f => setLoading(false));
    }, []);

    if (permissoes.length == 0)
        return <></>
    return (
        <>
            <h4 className='text-secondary mb-4'>Tipos de requerimentos</h4>
            <Row className='text-secondary'>
                {
                    dashboard.map((tipoRequerimento, index) => {
                        return (
                            <Col key={index} className='mb-2' md="12" lg="6">
                                <div className='shadow rounded overflow-hidden'>
                                    <h6 onClick={() => onClick(index)} role='button' className='titleDashboard text-white p-2 d-flex align-items-center justify-content-between mb-0'>{tipoRequerimento.tipoRequerimento} <FontAwesomeIcon icon={!showContent[index] ? faAngleUp : faAngleDown} /></h6>
                                    <div className={`cardContainer ${showContent[index] ? "" : "close"}`}>
                                        {
                                            tipoRequerimento.etapas.map((value, index) => {
                                                return (
                                                    <div key={index} onClick={() => { navigate("/admin/requerimentos/lista", { state: { etapa: value.etapa, etapaId: value.id, btnVoltar: "/admin/dashboard" } }) }} role="button" className='itemCard my-1 mx-2 d-flex align-items-center justify-content-between px-2 rounded'>
                                                        {value.etapa}
                                                        {value.status == "Azul" &&
                                                            <FontAwesomeIcon className='text-primary' icon={faCheck} style={{ width: "10px" }} />
                                                        }
                                                        {
                                                            value.status != "Azul" &&
                                                            <div className={`rounded-circle bg-${value.status == "Verde" ? "success" : value.status == "Amarelo" ? "warning" : "danger"}`} style={{ width: "10px", height: "10px" }}></div>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Col>
                        )
                    })
                }
            </Row>

        </>
    )
}